import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery } from "@/shared/utils/baseQuery";

export enum AnswerType {
  TEXT = "text",
  MANY_BUTTONS = "many_buttons",
  ONE_BUTTON = "one_button",
}

export type QuizAnswerDTO = {
  question_id: number;
  answer: string | number | boolean;
  answer_type:
    | AnswerType.TEXT
    | AnswerType.ONE_BUTTON
    | AnswerType.MANY_BUTTONS;
};

export interface QuizAnswerResponse {
  success: boolean;
}

export type QuizQuestion = {
  text: string;
  answers: Record<string, string> | null;
  answer_type: "one_button" | "many_buttons" | "many_button" | "text";
};

export type QuizQuestionsResponse = Record<string, QuizQuestion>;

export type QuizFindAnswersRequest = {
  data_type: ["full"];
};

export type QuizFindAnswersResponse = {
  user_id: number;
  answers: Record<string, string | number>;
};

export type ConsultationRequest = {
  date: string;
  time: string;
};

export interface ConsultationResponse {
  success: boolean;
}

export const quizApi = createApi({
  reducerPath: "quizApi",
  baseQuery: createBaseQuery("https://api.fitkeep.ru/"),
  endpoints: (builder) => ({
    getQuiz: builder.query<QuizQuestionsResponse, void>({
      query: () => ({
        url: "/quiz",
        method: "GET",
      }),
    }),
    findAnswers: builder.query<QuizFindAnswersResponse, QuizFindAnswersRequest>({
      query: (requestData) => ({
        url: "/quiz/answer/find",
        method: "POST",
        body: requestData,
      }),
    }),
    addAnswer: builder.mutation<QuizAnswerResponse, QuizAnswerDTO>({
      query: (answerData) => ({
        url: "/quiz/answer/add",
        method: "POST",
        body: answerData,
      }),
    }),
    bookConsultation: builder.mutation<ConsultationResponse, ConsultationRequest>({
      query: (consultationData) => ({
        url: "/quiz/consultation",
        method: "POST",
        body: consultationData,
      }),
    }),
  }),
});

export const { useAddAnswerMutation, useGetQuizQuery, useFindAnswersQuery, useBookConsultationMutation } = quizApi;
